const HEARTS = ['♥', '❤', '❥'];
const SEQUIN_CHARS = ['✦', '✧', '✶', '•', '◆'];
const PARTICLE_COUNT = 20;

const randomBetween = (min, max) => Math.random() * (max - min) + min;

const isCrazyThemeActive = () => {
  if (typeof document === 'undefined') return false;
  return document.documentElement.getAttribute('data-app-theme') === 'crazy';
};

export const triggerCrazyMenuBurst = (element) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  if (!isCrazyThemeActive() || !element || typeof element.getBoundingClientRect !== 'function') return;

  const rect = element.getBoundingClientRect();
  const originX = rect.left + rect.width / 2;
  const originY = rect.top + rect.height / 2;

  const burstRoot = document.createElement('div');
  burstRoot.className = 'crazy-burst-root';
  burstRoot.style.left = `${originX}px`;
  burstRoot.style.top = `${originY}px`;

  for (let index = 0; index < PARTICLE_COUNT; index += 1) {
    const isHeart = index % 3 !== 0;
    const particle = document.createElement('span');
    particle.className = `crazy-burst-particle ${isHeart ? 'crazy-burst-heart' : 'crazy-burst-sequin'}`;

    const angle = randomBetween(-165, 15) * (Math.PI / 180);
    const distance = randomBetween(52, 148);
    const dx = Math.cos(angle) * distance;
    const dy = Math.sin(angle) * distance;

    particle.style.setProperty('--dx', `${dx}px`);
    particle.style.setProperty('--dy', `${dy}px`);
    particle.style.setProperty('--scale', `${randomBetween(0.72, 1.28)}`);
    particle.style.setProperty('--rot', `${randomBetween(-180, 180)}deg`);
    particle.style.setProperty('--dur', `${randomBetween(620, 980)}ms`);
    particle.style.setProperty('--delay', `${randomBetween(0, 120)}ms`);

    particle.textContent = isHeart
      ? HEARTS[Math.floor(Math.random() * HEARTS.length)]
      : SEQUIN_CHARS[Math.floor(Math.random() * SEQUIN_CHARS.length)];

    burstRoot.appendChild(particle);
  }

  document.body.appendChild(burstRoot);
  window.setTimeout(() => {
    burstRoot.remove();
  }, 1300);
};
